let pdfMakePromise: Promise<typeof import('pdfmake/build/pdfmake')> | null = null;

export function getPdfMake() {
  if (!pdfMakePromise) {
    pdfMakePromise = Promise.all([
      import('pdfmake/build/pdfmake'),
      import('src/assets/pdfmake_vfs'),
    ]).then(([pdfMake, pdfMakeVfs]) => {
      (pdfMake as any).addVirtualFileSystem(pdfMakeVfs);

      pdfMake.addFonts({
        Poppins: {
          normal: 'Poppins-Regular.ttf',
          bold: 'Poppins-Bold.ttf',
          italics: 'Poppins-Italic.ttf',
          bolditalics: 'Poppins-BoldItalic.ttf',
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Bold.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-BoldItalic.ttf',
        },
      });

      return pdfMake;
    });
  }

  return pdfMakePromise;
}
